export default {
  mainContent: {
    id: 'a11y_keyboard_shortcut_main_content',
    defaultMessage: 'Main content',
  },
  search: {
    id: 'a11y_keyboard_shortcut_search',
    defaultMessage: 'Search',
  },
  home: {
    id: 'a11y_keyboard_shortcut_home',
    defaultMessage: 'Home',
  },
  cart: {
    id: 'a11y_keyboard_shortcut_cart',
    defaultMessage: 'Cart',
  },
  profile: {
    id: 'a11y_keyboard_shortcut_profile',
    defaultMessage: 'Profile',
  },
  helpCenter: {
    id: 'a11y_keyboard_shortcut_help_center',
    defaultMessage: 'Help center',
  },
  accessibilityStatement: {
    id: 'a11y_keyboard_shortcut_accessibility_statement',
    defaultMessage: 'Accessibility statement',
  },
  shoppingAssistant: {
    id: 'a11y_keyboard_shortcut_shopping_assistant',
    defaultMessage: 'Shopping assistant',
  },
}
